import { DropdownMenu as DropdownMenuPrimitive } from 'radix-ui';
import { FC } from 'react';

import { ChevronRightIcon } from '../../protons/icons';

import {
  $DropdownMenuContent,
  $DropdownMenuItem,
  $DropdownMenuLabel,
  $DropdownMenuSeparator,
  $DropdownMenuSubContent,
  $DropdownMenuSubTrigger,
} from './DropdownMenu.styles';

type DropdownMenuProps = React.ComponentProps<typeof DropdownMenuPrimitive.Root>;
const DropdownMenu: FC<DropdownMenuProps> = (props) => (
  <DropdownMenuPrimitive.Root data-slot="dropdown-menu" {...props} />
);

type DropdownMenuTriggerProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.Trigger
>;
const DropdownMenuTrigger: FC<DropdownMenuTriggerProps> = (props) => (
  <DropdownMenuPrimitive.Trigger
    data-slot="dropdown-menu-trigger"
    {...props}
  />
);

type DropdownMenuContentProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.Content
>;
const DropdownMenuContent: FC<DropdownMenuContentProps> = ({
  sideOffset = 4,
  ...props
}) => (
  <DropdownMenuPrimitive.Portal>
    <$DropdownMenuContent
      data-slot="dropdown-menu-content"
      sideOffset={sideOffset}
      {...props}
    />
  </DropdownMenuPrimitive.Portal>
);

type DropdownMenuLabelProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.Label
>;
const DropdownMenuLabel: FC<DropdownMenuLabelProps> = (props) => (
  <$DropdownMenuLabel data-slot="dropdown-menu-label" {...props} />
);

type DropdownMenuItemProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.Item
> & { $isActive?: boolean };
const DropdownMenuItem: FC<DropdownMenuItemProps> = ({
  $isActive,
  ...props
}) => (
  <$DropdownMenuItem
    data-slot="dropdown-menu-item"
    $isActive={$isActive}
    {...props}
  />
);

type DropdownMenuSeparatorProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.Separator
>;
const DropdownMenuSeparator: FC<DropdownMenuSeparatorProps> = (props) => (
  <$DropdownMenuSeparator data-slot="dropdown-menu-separator" {...props} />
);

type DropdownMenuSubProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.Sub
>;
const DropdownMenuSub: FC<DropdownMenuSubProps> = (props) => (
  <DropdownMenuPrimitive.Sub data-slot="dropdown-menu-sub" {...props} />
);

type DropdownMenuSubTriggerProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.SubTrigger
> & { $isActive?: boolean };
const DropdownMenuSubTrigger: FC<DropdownMenuSubTriggerProps> = ({
  children,
  $isActive,
  ...props
}) => (
  <$DropdownMenuSubTrigger
    data-slot="dropdown-menu-sub-trigger"
    $isActive={$isActive}
    {...props}
  >
    {children}
    <ChevronRightIcon size="16px" />
  </$DropdownMenuSubTrigger>
);

type DropdownMenuSubContentProps = React.ComponentProps<
  typeof DropdownMenuPrimitive.SubContent
>;
const DropdownMenuSubContent: FC<DropdownMenuSubContentProps> = (props) => (
  <DropdownMenuPrimitive.Portal>
    <$DropdownMenuSubContent
      data-slot="dropdown-menu-sub-content"
      {...props}
    />
  </DropdownMenuPrimitive.Portal>
);

export {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
};
